<template>
    <div class="news-card" v-if="cardArr != null">
        <div class="container">
            <div class="inner-container">
                <div class="news-card-desc-main default-desc-main-red" v-if="cardArr.first_elem_default != undefined">
                    <div class="desc-column-container">
                        <div class="column-left">
                            <div class="card-title">
                                <strong class="news-date">{{correctDate(cardArrDate)}}</strong>
                                <h2>{{parseTitle(cardArr.title)}}</h2>
                            </div>
                            <div class="desc-red">
                                <p v-for="item in cardArr.first_elem_default.desc_red" v-html="item.desc"></p>
                            </div>
                            <div class="col-img-mobile">
                                <img :src="cardArr.first_elem_default.img" alt="">
                            </div>
                            <div class="desc-base">
                                <p v-for="item in cardArr.first_elem_default.desc_red_under" v-html="item.desc"></p>
                            </div>
                        </div>
                        <div class="column-right">
                            <div class="col-img">
                                <img :src="cardArr.first_elem_default.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="news-standart-desc" v-if="cardArr.standart_big_desc != undefined && cardArr.standart_big_desc.init != undefined && cardArr.standart_big_desc.init == 'true'">
                    <div class="column-container">
                        <div class="col-left">
                            <div class="desc-col" v-html="cardArr.standart_big_desc.desc_left"></div>
                        </div>
                        <div class="col-right">
                            <div class="desc-col" v-html="cardArr.standart_big_desc.desc_right"></div>
                        </div>
                    </div>
                </div>
                
                <div class="news-card-desc-second" v-if="cardArr.second_news_elem != undefined && cardArr.second_news_elem != null">
                    <div class="second-desc-item" v-for="(item, index) in cardArr.second_news_elem" v-if="item.visible == 'true'">
                        <div class="col-left">
                            <div class="desc-info" v-html="item.editor"></div>
                        </div>
                        <div class="col-right">
                            <div class="desc-img">
                                <img :src="item.img" alt="">
                            </div>
                        </div>
                    </div>
                </div>

                <div class="news-card-big-desc" v-if="cardArr.big_info_element != undefined && cardArr.big_info_element.visible != undefined && cardArr.big_info_element.visible == 'true'">
                    <div class="container">
                        <div class="big-desc-item">
                            <div class="col-left">
                                <div class="desc-info" v-html="cardArr.big_info_element.desc_main"></div>
                            </div>
                            <div class="col-right">
                                <div class="desc-img">
                                    <img :src="cardArr.big_info_element.img" alt="">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="big-red-under-desc">
                        <div class="container">
                            <div class="column-container-big">
                                <div class="column-left">
                                    <div class="desc-info desc-info-white" v-html="cardArr.big_info_element.desc_left"></div>
                                </div>
                                <div class="column-right">
                                    <div class="desc-info desc-info-white" v-html="cardArr.big_info_element.desc_right"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="news-card-video" v-if="cardArr.video_news != undefined && cardArr.video_news.visible == 'true'">
                    <div class="container">
                        <div class="video-news-title" v-if="cardArr.video_news.title != ''">
                            <h2>{{cardArr.video_news.title}}</h2>
                        </div>
                        <div class="video-item">
                            <a href="#" class="link-open-modal" @click.prevent="initVideo = true" :class="{'disabled' : initVideo}">
                                <svgIcon name="play" class="icon-play"/>
                                <div class="video-item-img">
                                    <img :src="cardArr.video_news.img_preview" alt="">
                                </div>
                            </a>
                            <div class="video-player" :class="{'active' : initVideo}" v-if="initVideo">
                                <iframe :src="cardArr.video_news.video_link + '?autoplay=1&loop=1&rel=0&showinfo=0&vq=highres&color=white&iv_load_policy=3'" frameborder="0" allow="autoplay" allowfullscreen></iframe>
                            </div>
                        </div>
                    
                    </div>
                </div>

                <div class="news-card-gallery" v-if="cardArr.gallery_news != undefined && cardArr.gallery_news.visible == 'true'">
                    <div class="container">
                        <div class="gallery-title">
                            <h2>{{cardArr.gallery_news.title}}</h2>
                        </div>
                        <div class="news-card-gallery-carousel">
                            <swiper :options="swiperOption" ref="newsCardGalleryCarousel">
                                <swiper-slide v-for="(slide, index) in cardArr.gallery_news.gallery" :key="index">
                                    <div class="slide-pic" :style="'background-image: url(' + slide + ')'"></div>
                                </swiper-slide>
                            </swiper>
                            <div class="swiper-controls news-card-gallery-controls" v-if="cardArr.gallery_news.gallery.length > 1">
                                <div class="gal-news-btn-prev slider-btn">
                                    <svgIcon name="left-arrow" class="icon-left-arrow"/>
                                </div>
                                <div class="gal-news-btn-next slider-btn">
                                    <svgIcon name="right-arrow" class="icon-right-arrow"/>
                                </div>
                            </div>
                            <div class="swiper-pagination gal-news-pagination" v-if="cardArr.gallery_news.gallery.length > 1"></div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    // var convert = require('cyrillic-to-latin');
    var cyrillicToTranslit = require("cyrillic-to-translit-js")
    import {mapGetters} from 'vuex'
    import store from '@/store.js'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'news-card',
        components: {
            svgIcon,
        },
        data () {
            return {
                cardID: this.$route.params.id,
                lang: window.GlobalLang,
                cardArrDate: null,
                cardArr: null,
                anotherArr: null,
                initVideo: false,
                swiperOption: {
                    speed: 800,
                    loop: true,
                    observer: true,
                    observeParents: true,
                    effect: 'fade',
                    slidesPerView: 1,
                    watchSlidesVisibility: true,
                    lazy: {
                        loadPrevNext: true,
                        loadOnTransitionStart: true
                    },
                    autoplay: {
                        delay: 2500,
                        disableOnInteraction: true,
                    },
                    navigation: {
                        nextEl: '.gal-news-btn-next',
                        prevEl: '.gal-news-btn-prev',
                    },
                    pagination: {
                        el: '.gal-news-pagination',
                        type: 'bullets',
                        clickable: true,
                    },
                },
            }
        },
        methods: {
            parseTitle(title) {
                var temporalDivElement = document.createElement("div");
                temporalDivElement.innerHTML = title;
                return temporalDivElement.textContent || temporalDivElement.innerText || "";
            },
            correctDate(date) {
                var day = parseFloat(date.slice(8,10));
                var month = date.slice(5,7);
                var year = date.slice(0,4);
                var monthFont;
                var total;
                if (this.lang == 'kz/') {
                    if (month == '01') {
                        monthFont = 'Қаңтар'
                    } else if (month == '02') {
                        monthFont = 'Ақпан'
                    } else if (month == '03') {
                        monthFont = 'Наурыз'
                    } else if (month == '04') {
                        monthFont = 'Сәуiр'
                    } else if (month == '05') {
                        monthFont = 'Мамыр'
                    } else if (month == '06') {
                        monthFont = 'Маусым'
                    } else if (month == '07') {
                        monthFont = 'Шiлде'
                    } else if (month == '08') {
                        monthFont = 'Тамыз'
                    } else if (month == '09') {
                        monthFont = 'Қыркүйек'
                    } else if (month == '10') {
                        monthFont = 'Қазан'
                    } else if (month == '11') {
                        monthFont = 'Қараша'
                    } else if (month == '12') {
                        monthFont = 'Желтоқсан'
                    }
                } else if (this.lang == 'en/') {
                    if (month == '01') {
                        monthFont = 'January'
                    } else if (month == '02') {
                        monthFont = 'February'
                    } else if (month == '03') {
                        monthFont = 'March'
                    } else if (month == '04') {
                        monthFont = 'April'
                    } else if (month == '05') {
                        monthFont = 'May'
                    } else if (month == '06') {
                        monthFont = 'June'
                    } else if (month == '07') {
                        monthFont = 'July'
                    } else if (month == '08') {
                        monthFont = 'August'
                    } else if (month == '09') {
                        monthFont = 'September'
                    } else if (month == '10') {
                        monthFont = 'October'
                    } else if (month == '11') {
                        monthFont = 'November'
                    } else if (month == '12') {
                        monthFont = 'December'
                    }
                } else {
                    if (month == '01') {
                        monthFont = 'Января'
                    } else if (month == '02') {
                        monthFont = 'Февраля'
                    } else if (month == '03') {
                        monthFont = 'Марта'
                    } else if (month == '04') {
                        monthFont = 'Апреля'
                    } else if (month == '05') {
                        monthFont = 'Мая'
                    } else if (month == '06') {
                        monthFont = 'Июня'
                    } else if (month == '07') {
                        monthFont = 'Июля'
                    } else if (month == '08') {
                        monthFont = 'Августа'
                    } else if (month == '09') {
                        monthFont = 'Сентября'
                    } else if (month == '10') {
                        monthFont = 'Октября'
                    } else if (month == '11') {
                        monthFont = 'Ноября'
                    } else if (month == '12') {
                        monthFont = 'Декабря'
                    }
                }
                total = day + ' ' + monthFont + ' ' + year;
                return total;
            },
        },
        computed: mapGetters({
            pageSetup: 'loadNewsPage',
            currentCityArr: 'loadCurrentCityArr',
            newsItems: 'loadNewsItems',
            newsItemsDefault: 'loadNewsItemsDefault',
            newsItemsFilter: 'loadNewsItemsFilter',
            banerSystem: 'loadBanerSystem',
        }),
        beforeRouteEnter (to, from, next) {
            // console.log(to);
            store.dispatch('getNewsItems');
            store.dispatch('getNewsPageData');
            axios.get(window.url + window.GlobalLang + '/wp-json/wp/v2/news?slug=' + to.params.id).then(async (response) => {
                console.log(response);
                if (response.data.length != 0) {
                    next(vm => {
                        vm.cardArrDate = response.data[0].date;
                        vm.cardArr = response.data[0].acf;
                        vm.$store.commit('removePageLoaderImg');
                        vm.$parent.$refs.topProgress.done();
                    });
                } else {
                    next('/404', vm => vm.$parent.$refs.topProgress.fail());
                    //PUSH ON 404 PAGE
                }
            });
        },
        beforeCreate() {
            // this.$store.dispatch('getNewsPageData');
            // this.$store.dispatch('getNewsItems');
        },
        created () {
            document.body.dataset.page = 'news-card';

        },
        mounted () {
            // this.getData();
            // this.$store.watch(
            //     (state) => state.actionsItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.getData();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/news-page/news-card.scss';
    @import '@/styles/components/news-page/respond/news-card-respond.scss';
</style>